import React            from 'react';
import ChordService     from '../../services/ChordService';
import GuitarExChild    from "./GuitarExChild";
import LinkService from "../../services/LinkService";

class GuitarExParent extends React.Component {
    constructor(props) {
        super(props);
        let linkService = new LinkService()
        let chordService = new ChordService()
        this._helpLink = "#"
        const chordType  = window.location.href.split('/')[5]
        if(chordType==='note_identification') {
            let notes = chordService.getSingleNote();
            this._notes     = notes
            this._title     = 'Note Identification'
        }
        else if(chordType==='maj_min_dim_triads') {
            let notes = chordService.getTriad(chordType);
            this._notes     = notes
            this._title     = 'Major, Minor & Diminished Triads'
            this._helpLink = linkService.THEORY_TRI_MAJ_MIN_DIM
        }
        else if(chordType==='sus2_triads') {
            let notes = chordService.getTriad(chordType);
            this._notes     = notes
            this._title     = 'Suspended 2nd Triads'
            this._helpLink = linkService.THEORY_TRI_SUS2
        }
        else if(chordType==='sus4_triads') {
            let notes = chordService.getTriad(chordType);
            this._notes     = notes
            this._title     = 'Suspended 4th Triads'
            this._helpLink = linkService.THEORY_TRI_SUS4
        }
        // NEW
        else if(chordType==='diminished_triads') {
            let notes = chordService.getTriad(chordType);
            this._notes     = notes
            this._title     = 'Diminished Triads'
            this._helpLink = linkService.THEORY_TRI_DIM
        }
        else if(chordType==='major_triads') {
            let notes = chordService.getTriad(chordType);
            this._notes     = notes
            this._title     = 'Major Triads'
            this._helpLink = linkService.THEORY_TRI_MAJ
        }
        else if(chordType==='minor_triads') {
            let notes = chordService.getTriad(chordType);
            this._notes     = notes
            this._title     = 'Minor Triads'
            this._helpLink = linkService.THEORY_TRI_MIN
        }
        this._url       = '/exercises/guitar/' + chordType
        this._fretStart = chordService.getFretStart()
        this._fretEnd   = this._fretStart + 4
        this._scale     = chordService.getScale();
    }

    render() {
        return (
            <GuitarExChild url={this._url}
                           title={this._title}
                           helpLink = {this._helpLink}
                           fretStart = {this._fretStart}
                           fretEnd = {this._fretEnd}
                           scale = {this._scale}
                           notes={this._notes}></GuitarExChild>
        );}
}
export default GuitarExParent;
